import styled, { css } from 'styled-components';

const commonStyles = css`
  display: flex;
  align-items: center;
  justify-content: space-between;

  .MuiButton-root.Mui-disabled {
    color: ${({ theme }) => theme.palette.secondary.dark};
    box-shadow: none;
    background: ${({ theme }) => theme.palette.secondary.main};
  }

  .MuiButton-root {
    color: ${({ theme }) => theme.palette.common.white};
    background: ${({ theme }) => theme.palette.info.dark};
  }
`;
export const LeadsHeader = styled.div`
  ${commonStyles}
  margin-bottom: 20px;
  justify-content: flex-end;

  .MuiTypography-root {
    color: ${({ theme }) => theme.palette.info.dark};
  }
`;
export const LeadDetailsHeader = styled.div`
  ${commonStyles}
  padding: 20px 0px;

  .MuiTypography-root {
    color: ${({ theme }) => theme.palette.common.black};
  }

  h6.MuiTypography-root {
    color: ${({ theme }) => theme.palette.info.dark};
    font-weight: 800;
    cursor: pointer;
  }
`;
